import type { ArrayElement, LangKey } from "@sveabank/cc-common";
import type { IndexRouteObject, NonIndexRouteObject, useMatches } from "react-router";

type SveaRouteHandle = { heading: LangKey; subheading?: LangKey; subheading2?: LangKey };

type RouteMatch = ArrayElement<ReturnType<typeof useMatches>>;

type RouteMatchWithHandle = RouteMatch & { handle: SveaRouteHandle };

type NonIndexSveaRoute = Omit<NonIndexRouteObject, "handle" | "children"> & {
	handle?: SveaRouteHandle;
	children?: SveaRoute[];
};

type IndexSveaRoute = Omit<IndexRouteObject, "handle"> & {
	handle?: SveaRouteHandle;
};

export type SveaRoute = NonIndexSveaRoute | IndexSveaRoute;

export const routeHasHandle = (match: RouteMatch): match is RouteMatchWithHandle => {
	if (typeof match.handle === "object" && match.handle !== null && "heading" in match.handle)
		return true;
	return false;
};
